"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BannerModule_1 = tslib_1.__importDefault(require("../bannerModule/BannerModule"));
var ProductListing_1 = tslib_1.__importDefault(require("../productListing/ProductListing"));
var BannerModuleGroup_1 = tslib_1.__importDefault(require("../bannerModuleGroup/BannerModuleGroup"));
var BannerModuleStrip_1 = tslib_1.__importDefault(require("../bannerModuleStrip/BannerModuleStrip"));
var BannerModuleCarousel_1 = tslib_1.__importDefault(require("../bannerModuleCarousel/BannerModuleCarousel"));
var BannerModuleOverlay_1 = tslib_1.__importDefault(require("../bannerModuleOverlay/BannerModuleOverlay"));
var ExternalVideoModule_1 = tslib_1.__importDefault(require("../externalVideoModule/ExternalVideoModule"));
var VideoModule_1 = tslib_1.__importDefault(require("../videoModule/VideoModule"));
var TextLinks_1 = tslib_1.__importDefault(require("../textLinks/TextLinks"));
var ProductCarouselDesktop_1 = tslib_1.__importDefault(require("../productCarousel/ProductCarouselDesktop"));
var ProductCarouselMobile_1 = tslib_1.__importDefault(require("../productCarousel/ProductCarouselMobile"));
var StaticNavigationDesktop_1 = tslib_1.__importDefault(require("../staticNavigation/StaticNavigationDesktop"));
var StaticNavigationMobile_1 = tslib_1.__importDefault(require("../staticNavigation/StaticNavigationMobile"));
var ProductHighlight_1 = tslib_1.__importDefault(require("../productHighlight/ProductHighlight"));
var BannerSliderDesktop_1 = tslib_1.__importDefault(require("../bannerSlider/BannerSliderDesktop"));
var BannerSliderMobile_1 = tslib_1.__importDefault(require("../bannerSlider/BannerSliderMobile"));
var getWidget = function (widgetID, viewType) {
    if (viewType === void 0) { viewType = 'desktop'; }
    switch (widgetID) {
        case 'banner_module':
        case 'ad_banner_module':
            return BannerModule_1.default;
        case 'banner_module_group':
            return viewType === 'desktop' ? BannerModuleGroup_1.default : BannerModule_1.default;
        case 'banner_module_overlay':
            return viewType === 'desktop' ? BannerModuleOverlay_1.default : BannerModule_1.default;
        case 'banner_module_strip':
        case 'ad_banner_module_strip':
            return viewType === 'desktop' ? BannerModuleStrip_1.default : BannerModule_1.default;
        case 'banner_module_carousel':
        case 'ad_banner_module_carousel':
            return viewType === 'desktop' ? BannerModuleCarousel_1.default : BannerModule_1.default;
        case 'banner_slider':
        case 'ad_banner_slider':
            return viewType === 'desktop' ? BannerSliderDesktop_1.default : BannerSliderMobile_1.default;
        case 'listing':
        case 'product_listing':
            return ProductListing_1.default;
        case 'product_carousel':
            return viewType === 'desktop' ? ProductCarouselDesktop_1.default : ProductCarouselMobile_1.default;
        case 'product_highlight':
            return ProductHighlight_1.default;
        case 'external_video_module':
            return ExternalVideoModule_1.default;
        case 'video_module':
            return VideoModule_1.default;
        case 'text_links':
            return TextLinks_1.default;
        case 'static_navigation':
            return viewType === 'desktop' ? StaticNavigationDesktop_1.default : StaticNavigationMobile_1.default;
        default:
            return null;
    }
};
exports.default = getWidget;
//# sourceMappingURL=getWidget.js.map